import React from 'react';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import { FilePptOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { Button } from 'antd';
import { ManagerPublicationListItemFragment } from '../../../../../services/apolloGraphqlAppApiClient/models/types';

export interface IUseManagePublicationChaptersActionProps {
  publicationData: ManagerPublicationListItemFragment;
}

export interface IUseManagePublicationChaptersActionResult {
  managePublicationChaptersAction: ItemType;
}

export const useManagePublicationChaptersAction = (
  props: IUseManagePublicationChaptersActionProps,
): IUseManagePublicationChaptersActionResult => {
  const { publicationData } = props;

  const menuItemKey = `useManagePublicationChaptersAction-${publicationData.publicationId}`;

  const visible = true;

  return {
    managePublicationChaptersAction: visible
      ? {
          key: menuItemKey,
          style: {
            padding: 0,
          },
          label: (
            <NavLink to={`/publications/${publicationData.publicationId}/chapters`}>
              <Button
                type="text"
                icon={<FilePptOutlined style={{ fontSize: 12 }} />}
                style={{ padding: '5px 12px', borderRadius: 4, width: '100%', height: '100%' }}
              >
                Read chapters
              </Button>
            </NavLink>
          ),
          onClick: (menuInfo) => {
            // menuInfo.domEvent.preventDefault();
            menuInfo.domEvent.stopPropagation();
          },
        }
      : null,
  };
};
